import { AppErrorHandler, ScrolledByPipe, slideInAnimation } from '@aston/foundation';
import { Component, ErrorHandler, OnInit, inject } from '@angular/core';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { ChildrenOutletContexts } from '@angular/router';
import { filter, scan } from 'rxjs';

import { TopBarMobileComponent } from '../../../mobile-module/components/top-bar-mobile/top-bar-mobile.component';
import { MenuMobileComponent } from '../../../mobile-module/components/menu/menu-mobile.component';
import { MasterLayoutComponent } from '../master-layout/master-layout.component';
import { UserNotificationsStore } from '../../../notifications-module/stores';
import { SHARED_LAYOUT_COMPONENTS } from '../shared-layout-imports';
import { environment } from '../../../../environments/environment';

@Component({
	selector: 'mobile-layout',
	templateUrl: './mobile-layout.component.html',
	providers: [UserNotificationsStore],
	imports: [ SHARED_LAYOUT_COMPONENTS, NgbAlertModule, TopBarMobileComponent, MenuMobileComponent, ScrolledByPipe],
	animations: [slideInAnimation]
})
export class MobileLayoutComponent extends MasterLayoutComponent implements OnInit {

	private contexts = inject(ChildrenOutletContexts)

	errors$ = (inject(ErrorHandler) as AppErrorHandler).events$.pipe(scan((acc, e) => acc.concat(e), []))
	showErrors = !environment.production && !environment.staging

	ngOnInit() {
		this.currentUser$.pipe(filter(Boolean)).subscribe(() => {
			this.notifications.syncUnreadCount()
		});
	}

	getRouteAnimationData() {
		return this.contexts.getContext('primary')?.route?.snapshot?.data?.['animation'];
	}
}
